import Dashboard from "@/pages/Dashboard";
import Login from "@/pages/Login";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import UserManagement from "@/pages/UsersManagement";
import UploadDocument from "@/pages/UploadDocument";
import MyDocuments from "@/pages/MyDocuments";
import AllDocuments from "@/pages/AllDocuments";
import ReportsOld from "@/pages/ReportsOld";
import Help from "@/pages/Help";
import Settings from "@/pages/Settings";
import ReportsPage from "@/pages/Reports";
import CaseAnalysisReport from "@/pages/reports/CaseAnalysisReport";
import GDSummaryReport from "@/pages/reports/GDSummaryReport";
import DocumentStatusReport from "@/pages/reports/DocumentStatusReport";
import OfficerWiseReport from "@/pages/reports/OfficerWiseReport";
import PendingRecordsReport from "@/pages/reports/PendingRecordsReport";
import SuspectsVictimsReport from "@/pages/reports/SuspectsVictimsReport";
import IncidentTrendsReport from "@/pages/reports/IncidentTrendsReport";
import LocationHeatmapReport from "@/pages/reports/LocationHeatmapReport";
import CaseCategories from "@/pages/CaseCategories";
import Notifications from "@/pages/Notifications";
import SystemConfigPage from "@/pages/SystemConfig";
import UnauthorizedPage from "@/pages/UnauthorizedPage";
import PsWiseReport from "@/pages/reports/PsWiseReport";
import DocumentTypeReport from "@/pages/reports/DocumentTypeReport";
import UploadReport from "@/pages/criminalManagement/UploadReport";
import GoondaActCases from "@/pages/criminalManagement/GoondaActCases";
import Features from "../pages/Features";

function MainRoute() {
  const basicAccess = ['ADMIN', 'SUPERADMIN', 'SHO', 'CO', 'SDM', 'DM'];
  const adminAccess = ['ADMIN', 'SUPERADMIN', 'DM'];
  return (
    <>
      <Routes>
        <Route path="/" element={
          <ProtectedRoute allowedRoles={basicAccess}>
            <Dashboard />
          </ProtectedRoute>
        }/>
        <Route path="/user-management" element={
          <ProtectedRoute allowedRoles={adminAccess}>
            <UserManagement />
          </ProtectedRoute>
        }/>
        <Route path="/system-config" element={
          <ProtectedRoute allowedRoles={adminAccess}>
            <SystemConfigPage />
          </ProtectedRoute>
        }/>
        <Route path="/notifications" element={
          <ProtectedRoute allowedRoles={basicAccess}>
            <Notifications />
          </ProtectedRoute>
        }/>
        <Route path="/case-categories" element={
          <ProtectedRoute allowedRoles={basicAccess}>
            <CaseCategories />
          </ProtectedRoute>
        }/>
        <Route path="/upload-document" element={
          <ProtectedRoute allowedRoles={basicAccess}>
            <UploadDocument />
          </ProtectedRoute>
        }/>
        <Route path="/my-documents" element={
          <ProtectedRoute allowedRoles={basicAccess}>
            <MyDocuments />
          </ProtectedRoute>
        }/>
        <Route path="/all-documents" element={
          <ProtectedRoute allowedRoles={basicAccess}>
            <AllDocuments />
          </ProtectedRoute>
        }/>
        <Route path="/reports-old" element={
          <ProtectedRoute allowedRoles={adminAccess}>
            <ReportsOld />
          </ProtectedRoute>
        }/>
        <Route path="/reports/*" element={
          <ProtectedRoute allowedRoles={basicAccess}>
            <Routes>
              <Route path="" element={<ReportsPage />} />
              <Route path="case-analysis" element={<CaseAnalysisReport />} />
              <Route path="gd-summary" element={<GDSummaryReport />} />
              <Route path="document-status" element={<DocumentStatusReport />} />
              <Route path="officer-wise" element={<OfficerWiseReport />} />
              <Route path="pending-records" element={<PendingRecordsReport />} />
              <Route path="suspects-victims" element={<SuspectsVictimsReport />} />
              <Route path="incident-trends" element={<IncidentTrendsReport />} />
              <Route path="location-heatmap" element={<LocationHeatmapReport />} />
              <Route path="ps-wise-report" element={<PsWiseReport />} />
              <Route path="crpc-107" element={<DocumentTypeReport typeKey="107" />} />
              <Route path="crpc-111" element={<DocumentTypeReport typeKey="111" />} />
              <Route path="crpc-117" element={<DocumentTypeReport typeKey="117" />} />
              <Route path="crpc-116-3" element={<DocumentTypeReport typeKey="116_3" />} />
            </Routes>
          </ProtectedRoute>
        }/>
        <Route path="/criminal-management/*" element={
          <ProtectedRoute allowedRoles={basicAccess}>
            <Routes>
              <Route path="upload-report" element={<UploadReport />} />
              <Route path="reports" element={<GoondaActCases />} />
            </Routes>
          </ProtectedRoute>
        }/>
        <Route path="/settings" element={
          <ProtectedRoute allowedRoles={basicAccess}>
            <Settings />
          </ProtectedRoute>
        }/>
        <Route path="/help" element={
          <ProtectedRoute allowedRoles={basicAccess}>
            <Help />
          </ProtectedRoute>
        }/>
        <Route path="/login" element={<Login />} />
        <Route path="/features" element={<Features />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
      </Routes>
    </>
  );
}

export default MainRoute;
